import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "./DataSlice";
import trainingCartReducer from "../config/UserSlice";

export default configureStore({
    reducer: {
        data: dataReducer,
        custom: trainingCartReducer
    },
})